import { render, staticRenderFns } from "./SubirArchivo.vue?vue&type=template&id=287d72ac&scoped=true"
import script from "./SubirArchivo.vue?vue&type=script&lang=js"
export * from "./SubirArchivo.vue?vue&type=script&lang=js"
import style0 from "./SubirArchivo.vue?vue&type=style&index=0&id=287d72ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287d72ac",
  null
  
)

export default component.exports